import { render, staticRenderFns } from "./teamsForT8OrT12.vue?vue&type=template&id=70770f59&scoped=true"
import script from "./teamsForT8OrT12.vue?vue&type=script&lang=js"
export * from "./teamsForT8OrT12.vue?vue&type=script&lang=js"
import style0 from "./teamsForT8OrT12.vue?vue&type=style&index=0&id=70770f59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70770f59",
  null
  
)

export default component.exports